export default {
  title: 'Deliverect',
  form: {
    channel_link_id: {
      label: 'ID de enlace de canal: ',
    },
    store_id: {
      label: 'ID de ubicación externa: ',
    },
    store_provisioning_url: {
      label: 'URL de aprovisionamiento de tienda: ',
    },
  },
  buttons: {
    save: 'Guardar',
  },
  toasts: {
    error: 'Error al guardar los cambios',
    success: 'Los cambios se guardaron',
  },
  instructions: {
    title: 'Instrucciones de configuración:',
    step_1:
      'Abre la página <Link>«Ubicaciones»</Link> en Deliverect, expande la ubicación correspondiente y haz clic en el botón «+ Channel link».',
    step_2:
      'Completa la información necesaria. En el paso «Selecciona tu plataforma de entrega online», elige «Food Amigos».',
    step_3:
      'Completa todos los pasos. Luego, en la página «Ubicaciones», haz clic en «Editar» en el canal «Food Amigos».',
    step_4: 'En la barra lateral, haz clic en la pestaña «Channel connection» y completa estos datos:',
    step_5: 'Guarda los cambios haciendo clic en el botón «Guardar» en la parte superior derecha.',
    step_6:
      'Una vez guardado, haz clic en el icono «Más» en la parte superior derecha, luego en «Register» y después en «Activate».',
    step_7: 'Vuelve a la pestaña «General», cambia el «Estado de integración» a «Activo» y guarda los cambios.',
    outro: 'Después puedes enviar el menú desde Deliverect y crear un pedido de prueba.',
  },
  connected: {
    title: 'Deliverect está conectado',
    description: 'Esta integración está configurada.',
  },
};
